import Header from "../sections/header";
import Scrollbar from "../components/scrollbar";
import Info from "../sections/info";
import Participate from "../sections/participate";
import Players from "../sections/players";
import History from "../sections/history";
import Footer from "../sections/footer";
import React from "react";
import {Link} from "react-router-dom";

export default function Impressum() {
    return (
        <div className={"min-h-[100vh] bg-gradient-to-b from-blue-light to-blue-dark flex flex-col gap-6 " +
            "overflow-y-hidden text-light"}>
            <Header/>
            <Scrollbar/>
            <div className="flex flex-col gap-6 px-2">
                <h1 className="text-3xl font-bold">Impressum für mcworld.run</h1>
                <div>
                    <p>Rafael Eisler</p>
                    <p>c/o Kartell07</p>
                    <p>Arbeitergasse 7</p>
                    <p>1050 Wien</p>
                    <p>Österreich</p>
                </div>

                <div className="flex flex-col gap-1">
                    <p>Unternehmensgegenstand: Multimedia Agentur</p>
                    <p>UID-Nummer: ATU70335069</p>
                    <p>E-Mail: <a href="mailto://business@venicraft.at" className="underline">business@venicraft.at</a></p>
                    <p>Mitglied bei: Wirtschaftskammer Wien (WKW)</p>
                    <p>Berufsrecht: Gewerbeordnung (abrufbar unter www.ris.bka.gv.at)</p>
                    <p>Berufsbezeichnung: Multimedia Agentur (verliehen in Österreich)</p>
                </div>
                <div className="flex flex-col gap-2">
                    <h2 className="text-2xl font-bold my-2">Hinweis gemäß § 25 Mediengesetz:</h2>
                    <p>Verantwortlich für den Inhalt: Rafael Eisler</p>
                    <h3 className="text-xl font-semibold mt-1">Haftungsausschluss:</h3>
                    <p>Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer
                        Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.</p>
                    <h3 className="text-xl font-semibold mt-1">Plattform der EU-Kommission zur Online-Streitbeilegung:</h3>
                    <a href="https://ec.europa.eu/consumers/odr/" className="underline">
                        ec.europa.eu/consumers/odr/
                    </a>
                </div>
                <p>Dieses Impressum gilt auch für die Social-Media-Präsenzen von mcworld.run.</p>
            </div>
            <Footer/>
        </div>
    );
}